import PropTypes from 'prop-types';
import React from 'react';
import SearchItem from './item.jsx';

export default class SearchResults extends React.Component {
    static displayName = 'SearchResults';

    static propTypes = {
        loadMore: PropTypes.func.isRequired,
        results: PropTypes.array.isRequired,
        total: PropTypes.number.isRequired,
        type: PropTypes.oneOf(['markup', 'content']),
        content: PropTypes.shape({
            title: PropTypes.string.isRequired,
        }),
        stealFocus: PropTypes.bool,
    };

    onMore() {
        this.props.loadMore(this.props.type);
    }

    renderItems() {
        const { results, stealFocus } = this.props;

        return results.map(function(result, idx) {
            // These don't have a unique value that would allow react to
            // optimize removing/sorting, so we'll have to settle for
            // using the index. Since search results don't get removed or
            // re-sorted we aren't loosing much here.
            // React also wants keys to be strings.
            return (
                <SearchItem
                    result={result}
                    key={'result' + idx}
                    stealFocus={idx === 0 && stealFocus}
                />
            );
        });
    }

    renderMoreButton() {
        const { results, total } = this.props;

        if (results.length < total) {
            return (
                <button
                    className="btn btn-primary js-more-button"
                    onClick={this.onMore.bind(this)}
                >
                    More Results
                </button>
            );
        }
    }

    render() {
        const { results, content } = this.props;
        const title = content
            ? `Search results for '${content.title}'`
            : `Search results for all materials and notes`;

        if (results.length === 0) {
            return (
                <div>
                    <h1>{title}</h1>
                    <p>
                        Your search returned <strong>0</strong> results
                    </p>
                </div>
            );
        }

        return (
            <div className="result-list" role="main">
                <h1>{title}</h1>
                <ul>{this.renderItems()}</ul>
                {this.renderMoreButton()}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/search/results.jsx